import React, { useState } from "react";
import { ReactComponent as Cancel } from "../../../Assets/Image/svg/cancel.svg";
import { useForm, Controller } from "react-hook-form";
import { BtnPrimary } from "../../../Components/share/buttons/Btn";
import useFetch from "../../../Hooks/useFetch";

function ModalIdea({ close, idea, getUserIdeas, editIdeaId }) {
    const [priority, setPriority] = useState();
    const [call, setCall] = useState();

    const {
        register,
        handleSubmit,
        control,
        formState: { errors },
    } = useForm();

    const editIdeaPriority = useFetch({
        method: "POST",
        url: `UserBootCampPriorityService`,
        noHeader: false,
        caller: getUserIdeas,
        trigger: false,
        data: call,
    });

    const submitForm = () => {
        //TODO : pak kardane modal bad az patch

        const formData = new FormData();

        formData.append("user_idea_id", editIdeaId);
        formData.append("priority_number", priority);

        setCall(formData);
        editIdeaPriority.reFetch();

        close();
    };

    return (
        <div className="AddnewsupportTicket relative max-w-[73rem]">
            <button
                onClick={() => close(false)}
                className="AddnewsupportTicket-cancel absolute  "
            >
                <div>
                    <Cancel />
                </div>
            </button>
            <p className=" text-[#77498F] text-[2rem] leading-[3.2rem] font-bold text-center">
                شرح ایده
            </p>
            <div className=" mt-[5.6rem]">
                <div className=" grid grid-cols-2 gap-x-0 gap-y-[2rem]">
                    <p className=" text-black font-normal text-[1.8rem] leading-[3.2rem]">
                        نام ایده:
                    </p>
                    <p className=" text-[#212121E5] font-normal text-[1.4rem] leading-[2.4rem]">
                        {idea?.idea_name}
                    </p>
                </div>
                <div className=" mt-[1.5rem]">
                    <p className=" text-black  font-normal text-[1.8rem] leading-[3.2rem]">
                        شرح ایده:
                    </p>
                    <p className=" text-[#212121E5]  font-normal text-[1.4rem] leading-[2.4rem]">
                        {idea?.idea_description}
                    </p>
                </div>
                <form onSubmit={handleSubmit(submitForm)}>
                    <div className=" flex flex-row items-center justify-between mt-[4.5rem]">
                        <p className=" text-[#212121E5] font-normal text-[1.8rem] leading-[3.2rem]">
                            تنظیم اولویت ایده برای من:
                        </p>
                        <div>
                            <Controller
                                control={control}
                                name="PriceForm"
                                rules={{ required: true }}
                                render={({ field: { onChange, value } }) => (
                                    <div
                                        onChange={(e) =>
                                            setPriority(e.target.value)
                                        }
                                        className="flex items-center justify-center"
                                    >
                                        <div className=" flex items-center justify-center mr-[2.7rem]">
                                            <input
                                                type="radio"
                                                name="radio-1"
                                                className="PriceForm radio-lg"
                                                value={1}
                                            />
                                            <p className=" font-normal text-[1.4rem] leading-[2.4rem] mr-[0.4rem]">
                                                اول
                                            </p>
                                        </div>
                                        <div className=" flex items-center justify-center mr-[2.7rem]">
                                            <input
                                                type="radio"
                                                name="radio-1"
                                                className="PriceForm radio-lg"
                                                value={2}
                                            />
                                            <p className=" font-normal text-[1.4rem] leading-[2.4rem] mr-[0.4rem]">
                                                دوم
                                            </p>
                                        </div>
                                        <div className=" flex items-center justify-center mr-[2.7rem]">
                                            <input
                                                type="radio"
                                                name="radio-1"
                                                className="PriceForm radio-lg"
                                                value={3}
                                            />
                                            <p className=" font-normal text-[1.4rem] leading-[2.4rem] mr-[0.4rem]">
                                                سوم
                                            </p>
                                        </div>
                                        <div className=" flex items-center justify-center mr-[2.7rem]">
                                            <input
                                                type="radio"
                                                name="radio-1"
                                                className="PriceForm radio-lg"
                                                value={4}
                                            />
                                            <p className=" font-normal text-[1.4rem] leading-[2.4rem] mr-[0.4rem]">
                                                چهارم
                                            </p>
                                        </div>
                                    </div>
                                )}
                            />
                        </div>
                    </div>
                    <div className="text-left mt-[3rem]">
                        <BtnPrimary
                            text="ثبت اولویت"
                            type="submit"
                            className="px-16 py-7 "
                            onClick={() => submitForm()}
                        />
                    </div>
                </form>
            </div>
        </div>
    );
}

export default ModalIdea;
